
import { getPlatform } from "../../../../../helpers/index";
import { OfferDataInterface } from "../@types/savedMethods";
import { doCheckOffers } from "../../../../../logics/src/utils/checkOffers";
import { paytmAddMoney } from "../../../../../store/payment/services";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { PAYMENT_MODES } from "constants/paymentModes";
import { getOfferMessages } from "../../../../../logics/src/utils/helpers";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { BUTTON_TYPE } from "constants/index";
import { formatNumber } from "helpers/utils/numberFormatter";

export const getSavedPaytmContextData = ({
    paymentContext,
    applicationData,
    orderAmount: grandTotal,
    doPayment,
    toggleOfferBottomSheet,
    strikedPaymentText,
    theme,
}: any) => {
    const platform = getPlatform();
    const deviceType = applicationData?.deviceType;

    const paymentInfo = paymentContext?.paymentInfo;
    const setLoading = paymentContext?.setLoading;
    const isPaytmConnected = paymentInfo?.isPaytmConnected;
    const cartRules = paymentContext?.offersData;
    const offerData: OfferDataInterface = doCheckOffers(true, "paytm_auto_debit", cartRules, paymentInfo);
    const paytmDetails = paymentContext?.paytmDetails;
    const cartInfo = paymentContext?.cartInfo;
    const initialOrderAmount = cartInfo?.grandTotal;
    

    let phoneNumber = '';
    const payTmData = {
        unAuthorizedPaytmError: false,
        isPayTmUser: false,
        paytmBalance: 0,
    };
    let amountToAdd = 0;

    const title = getStringFromId(
        VERNACULAR_STRING_IDS.WALLET,
        VERNACULAR_DEFAULT_MESSAGES.WALLET
    );
    const subTitle = getStringFromId(
        VERNACULAR_STRING_IDS.SAVED_PAYTM_WALLET_SUBTITLE,
        VERNACULAR_DEFAULT_MESSAGES.SAVED_PAYTM_WALLET_SUBTITLE
    );
    let payTmBalance = payTmData?.paytmBalance;
    const amountToPayText = getStringFromId(
        VERNACULAR_STRING_IDS.DYNAMIC_AMOUNT_TO_PAY,
        `Pay ₹${formatNumber(grandTotal)}`,
        { count: grandTotal }
    );
    const addMoneyText = getStringFromId(
        VERNACULAR_STRING_IDS.ADD_MONEY,
        VERNACULAR_DEFAULT_MESSAGES.ADD_MONEY
    );

    let revisedPayNowText = getStringFromId(
        VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
        `Pay ₹${formatNumber(offerData?.finalOrderAmount)} &nbsp; <del> ₹${formatNumber(initialOrderAmount)}</del>`,
        {
            oldAmount: initialOrderAmount,
            newAmount: offerData?.finalOrderAmount || '',
        }
    );

    /**
     * function to add money in paytm wallet
     */
    const handlePayTmAddMoney = async () => {
        const params = {
            amount: amountToAdd,
            deviceType,
        };
        return paytmAddMoney(params).then((res: {
            success: boolean;
            message: string;
            userTrackingId: string;
            statusCode: string;
            data: {
                url: string;
                mid: string;
                txn_AMOUNT: string;
                channel_ID: string;
                industry_TYPE_ID: string;
                website: string;
                order_ID: string;
                cust_ID: string;
                callback_URL: string;
                checksumhash: string;
                sso_TOKEN: string;
                request_TYPE: string;
                merc_UNQ_REF: string;
            };
        }) => ({ res }));
    };

    if( isPaytmConnected && paytmDetails?.phone && !paytmDetails?.isExpired){
        payTmData.unAuthorizedPaytmError = false;
        payTmData.isPayTmUser = true;
        payTmData.paytmBalance = paytmDetails?.balance;
    }

    const handlePayTmSubmit = () => {
        setLoading(true);
        doPayment(PAYMENT_MODES.PAYTM,{
            amountToAdd,
            isPayTmUser: payTmData?.isPayTmUser,
            handlePayTmAddMoney,
            mode: PAYMENT_MODES.PAYTM,
            offerData,
            // Required for adding Money to wallet and giftcard purchase
            grandTotal,
            paymentInfo: phoneNumber, // required in FC-2263
            isSaved:true
        });
    };


    const isPayTmUser = payTmData?.isPayTmUser;
    payTmBalance = payTmData?.paytmBalance;
    // calculating amountToAdd only when order Amount greater then paytm balance
    let amountToBeAdd: string | number = 0;
    const orderAmountWithOffer =  offerData?.finalOrderAmount ?  offerData?.finalOrderAmount : grandTotal;

    if (orderAmountWithOffer <= payTmBalance) {
        amountToAdd = amountToBeAdd;
    }else{
        
        amountToBeAdd = (orderAmountWithOffer - payTmBalance).toFixed(2);
        if (isPayTmUser && amountToBeAdd) {
            amountToAdd = Math.ceil(amountToBeAdd as string);
        }

    }
    const payNowText = amountToAdd ? addMoneyText : amountToPayText;
    revisedPayNowText = amountToAdd ? '' : !revisedPayNowText ? strikedPaymentText : revisedPayNowText;

    const paytmLowBalanceText = getStringFromId(
        VERNACULAR_STRING_IDS.DYANMIC_PAYTM_LOW_BALANCE,
        `Low Balance you need ₹${formatNumber(amountToAdd)} more in your account`,
        { amount: amountToAdd }
    );
    const alertLowBalanceText = amountToAdd > 0 ? paytmLowBalanceText : '' ;
    
    const config = {
        title,
        subTitle,
        leadingIcon: getIcons(platform, ICONS_NAMES.SAVED_PAYTM),
        offerText: '',
        balanceText: `₹${formatNumber(payTmBalance)}`,
        alert: {
            text: alertLowBalanceText,
            warn: true,
            leadingIcon: getIcons(platform, ICONS_NAMES.WARN_ICON),
        },
        payNowText,
        revisedPayNowText: offerData?.finalOrderAmount ? revisedPayNowText : '',
        doPayment: handlePayTmSubmit,
        amountToAdd,
        amountLabelText: 'Money',
        offerMessages: getOfferMessages(
            offerData,
            theme,
            () => toggleOfferBottomSheet(offerData) 
        ),
        pymentMethod:PAYMENT_MODES.PAYTM,
        theme,
        offerDetailConfig:{},
        priority: 0,
        buttonType: BUTTON_TYPE.MEDIUM,
    };
    return config ;

}